import {
  FAIL_FETCH, FETCH_SEARCH_TERMS, FETCH_PUSH_NOTIFICATIONS, FETCH_BANNER_CONTENT,
  LOAD_SEARCH_TERMS, LOAD_PUSH_NOTIFICATIONS, LOAD_BANNER_CONTENT
} from '../Actions/Other'
import { emptyContent } from './Overview'

const emptyPushNotification = {
  notificationType: '',
  message: '',
  view: 0,
  opens: 0
}

const initialState = {
  searchTerms: ['Loading'],
  pushNotifications: [emptyPushNotification.message = 'OFFLINE'],
  bannerImages: [emptyContent.title = 'OFFLINE'],
  bannerImagesLength: 0
}

/**
  * OtherReducer
  * @desc reducer that handles data deiplayed on the Other page
  * @param {Object} state
  * @param {action} action
  * @return {Object} state updated state
*/
export default function OtherReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case FETCH_SEARCH_TERMS:
      return Object.assign({}, state, { searchTerms: ['Loading'] })
    case LOAD_SEARCH_TERMS:
      return Object.assign({}, state, { searchTerms: action.data.allSearchTerms.searchTerms })
    case FETCH_PUSH_NOTIFICATIONS:
      return Object.assign({}, state, { pushNotifications: [Object.assign({}, emptyPushNotification, { message: 'Loading' })] })
    case LOAD_PUSH_NOTIFICATIONS:
      return Object.assign({}, state, { pushNotifications: action.data.allPushNotifications.pushNotifications, pushNotificationsLength: action.data.allPushNotifications.count })
    case FETCH_BANNER_CONTENT:
      return Object.assign({}, state, { bannerImages: [Object.assign({}, emptyContent, { title: 'Loading' })] })
    case LOAD_BANNER_CONTENT:
      return Object.assign({}, state, { bannerImages: action.data.getContentAnalytics.content, bannerImagesLength: action.data.getContentAnalytics.count })
    case FAIL_FETCH:
      return state
    default:
      return state
  }
}
